import { useCallback, useMemo } from 'react'

import { cn } from '@/lib/utils'
import { Search } from '@mui/icons-material'
import { TextField } from '@mui/material'
import { SearchInputProps } from './@types'

export function SearchInput<TData>({
  table,
  inputProps,
}: SearchInputProps<TData>) {
  const inputValue = useMemo<string>(() => {
    let value = ''
    const column = table.getColumn(String(inputProps?.name))
    if (column) value = column.getFilterValue() as string
    return value
  }, [inputProps, table])

  const onInputValueChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const column = table.getColumn(String(inputProps?.name))
      if (column) column.setFilterValue(event.target.value)
    },
    [inputProps, table],
  )

  return (
    <div
      className={cn(
        inputProps.className,
        'bg-[#37393F] rounded-[12px] flex items-center relative',
      )}
    >
      <TextField
        {...inputProps}
        className={cn('absolute top-0 left-0')}
        sx={{
          '& .MuiInputBase-root': {
            background: '#37393F',
            borderRadius: '8px',
          },
          '& fieldset': {
            borderRadius: '8px',
          },
          '& input': {
            py: '8px',
          },
        }}
        placeholder={inputProps.placeholder ?? 'Procurar'}
        value={inputValue}
        onChange={onInputValueChange}
        name={String(inputProps.name)}
      />

      <Search className="absolute right-4" />
    </div>
  )
}
